/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { tenantsGet } from "../../funcs/tenantsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$inboundSchema,
};

export const tool$tenantsGet: ToolDefinition<typeof args> = {
  name: "tenants_get",
  description: `Get tenant details

Retrieves details of a specific tenant`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await tenantsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
